import { ListItemIcon, ListItemText, Stack } from "@mui/material";
import { ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";

import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission, AssetSubscriptionPlanDto } from "@/core/api/generated/v1";

import AuthorizedMenuItem from "../../Auth/AuthorizedMenuItem";
import EntityMenu from "../../EntityMenu/EntityMenu";
import AppIcon from "../../Icons/AppIcon";
import AppLink from "../../Link/AppLink";
import HeaderMenuItem from "../../Menu/HeaderMenuItem";
import AssetSubscriptionPlanDeleteModal from "./AssetSubscriptionPlanDeleteModal";

enum ActionFlags {
  Edit = "Edit",
  Delete = "Delete",
  CreateAssetSubscription = "CreateAssetSubscription",
}
const defaultDisplayProps = {
  actions: {
    edit: true,
    delete: true,
    createAssetSubscription: true,
  },
};

interface TriggersProps {
  entity?: AssetSubscriptionPlanDto | null;
  definition: typeof ActionFlags;
  handleClose: () => void;
  startAction: (props: ActionFlags) => void;
}

interface Props {
  entity?: AssetSubscriptionPlanDto | null;
  disabled?: boolean;
  onUpdate: ((newValue: AssetSubscriptionPlanDto | null | undefined) => void) | undefined;
  onDelete?: (() => void) | undefined;
  displayProps?: Partial<typeof defaultDisplayProps>;
  customActions?: (props: TriggersProps) => ReactNode;
}

export default function AssetSubscriptionPlanMenu({
  entity,
  disabled,
  customActions,
  onUpdate,
  onDelete,
  displayProps = defaultDisplayProps,
}: Props) {
  displayProps = {
    ...defaultDisplayProps,
    ...displayProps,
  };
  return (
    <EntityMenu
      definition={ActionFlags}
      entity={entity}
      disabled={disabled}
      actionTriggers={({ handleClose, startAction }) => (
        <>
          {customActions &&
            customActions({
              entity,
              definition: ActionFlags,
              handleClose,
              startAction,
            })}
          {displayProps?.actions?.edit && (
            <AuthorizedMenuItem
              permissions={[AppPermission.AssetSubscriptionPlanManage]}
              component={RouterLink}
              to={ROUTE_PATH.ASSET_SUBSCRIPTION_PLAN_EDIT(entity?.id)}
            >
              <ListItemIcon>
                <AppIcon of='edit' fontSize='small' />
              </ListItemIcon>
              <ListItemText>Edit</ListItemText>
            </AuthorizedMenuItem>
          )}
          {displayProps?.actions?.delete && (
            <AuthorizedMenuItem
              permissions={[AppPermission.AssetSubscriptionPlanManage]}
              onClick={() => startAction(ActionFlags.Delete)}
            >
              <ListItemIcon>
                <AppIcon of='delete' fontSize='small' />
              </ListItemIcon>
              <ListItemText>Delete</ListItemText>
            </AuthorizedMenuItem>
          )}
          {displayProps?.actions?.createAssetSubscription && (
            <>
              <HeaderMenuItem primaryTitle='Quick actions' />
              <AuthorizedMenuItem
                permissionsAny={[AppPermission.AssetSubscriptionManage]}
                component={AppLink}
                to={ROUTE_PATH.ASSET_SUBSCRIPTION_CREATE({
                  planId: entity?.id,
                })}
              >
                <ListItemIcon>
                  <AppIcon of='assetSubscription' fontSize='small' />
                </ListItemIcon>
                <ListItemText>New asset subscription</ListItemText>
              </AuthorizedMenuItem>
            </>
          )}
        </>
      )}
      actionHandlers={({ currentAction, cancelAction, completeAction }) => (
        <Stack>
          {/* Delete */}
          {entity && (
            <AssetSubscriptionPlanDeleteModal
              entity={entity}
              open={currentAction === ActionFlags.Delete}
              onClose={() => cancelAction()}
              onDelete={() => {
                console.log(1);

                onDelete && onDelete();
                completeAction();
              }}
            />
          )}
        </Stack>
      )}
    />
  );
}
